import { render, staticRenderFns } from "./ManuscriptNewEdit.vue?vue&type=template&id=53a587ba&scoped=true&"
import script from "./ManuscriptNewEdit.vue?vue&type=script&lang=js&"
export * from "./ManuscriptNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a587ba",
  null
  
)

export default component.exports